'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cart = require('ifeis-isomorphic/lib/redux/actions/cart');

var _ngRedux = require('ng-redux');

var _ngRedux2 = _interopRequireDefault(_ngRedux);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BalanceDueReportController = function () {
  function BalanceDueReportController(feis, $ngRedux, fRouterHistoryService, msgService, fCSVReportsService) {
    var _this = this;

    _classCallCheck(this, BalanceDueReportController);

    this.fRouterHistoryService = fRouterHistoryService;
    this.$ngRedux = $ngRedux;
    this.msgService = msgService;
    this.fCSVReportsService = fCSVReportsService;
    this.feis = feis;
    this.headers = ['Account Owner/Dancer Name', 'Email Id', 'Balance Due'];

    this.$ngRedux.dispatch((0, _cart.getAccountsWithPartialBalancesForFeis)(feis.id)).then(function (response) {
      _this.unpaidParticipantsGroupedByAccount = response.payload.reduce(function (aggregator, resp) {
        var person = resp.person.id !== resp.acct.id && resp.person || {};
        var persons = [];
        persons.push(person);
        if (!aggregator[resp.acct.id]) {
          aggregator[resp.acct.id] = {
            account: resp.acct,
            balance: resp.rel.balance,
            persons: persons
          };
        } else if (resp.acct.fname !== resp.person.fname || resp.acct.lname !== resp.person.lname) {
          aggregator[resp.acct.id].persons.push(resp.person);
        }
        return aggregator;
      }, {});
    });
  }

  _createClass(BalanceDueReportController, [{
    key: 'back',
    value: function back() {
      this.fRouterHistoryService.back();
    }
  }, {
    key: 'generateExcelReport',
    value: function generateExcelReport() {
      var _this2 = this;

      var csv = [];
      csv.push(this.headers);
      Object.keys(this.unpaidParticipantsGroupedByAccount).forEach(function (u) {
        csv.push([_this2.unpaidParticipantsGroupedByAccount[u].account.fname + ' ' + _this2.unpaidParticipantsGroupedByAccount[u].account.lname, _this2.unpaidParticipantsGroupedByAccount[u].account.email, '$' + _this2.unpaidParticipantsGroupedByAccount[u].balance.toFixed(2)]);
        _this2.unpaidParticipantsGroupedByAccount[u].persons.forEach(function (dancer) {
          if (dancer.fname && dancer.lname) {
            csv.push([dancer.fname + ' ' + dancer.lname]);
          }
        });
        csv.push(['']);
      });

      this.fCSVReportsService.prepareCSV(csv, this.feis.slug + '_Account_Balances.csv');
    }
  }]);

  return BalanceDueReportController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.reports.balance-due-report', []).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.reports.balance-due-report', {
    url: '/balance-due-report',
    template: require('./tpl.html'),
    controller: BalanceDueReportController,
    controllerAs: 'ctrl'
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/reports/balance-due-report/index.js
// module id = 558
// module chunks = 0